import AbstractRepository from "@/repositories/AbstractRepository";

export default class AllocationTypeRepository extends AbstractRepository {
    protected static resource: string = "ptf-budget-allocationtype";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
        "owner.uuid",
    ];
}
